<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="headline">
                Przekaż do partnera
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-text-field
                                v-model="handOverData.email"
                                :rules="formRules.email"
                                class="pt-0"
                                type="email"
                                label="E-mail partnera"
                            ></v-text-field>
                            <v-select
                                class="mt-0 pt-0"
                                v-model="handOverData.typeForPartner"
                                :rules="formRules.typeForPartner"
                                label="Typ"
                                :items="typeValues"
                                item-value="value"
                                item-text="text"
                                hide-details
                            ></v-select>
                            <v-checkbox
                                v-if="order.status !== 'partnerPriced'"
                                v-model="handOverData.partnerPricing"
                                class="pt-0"
                                label="Wymaga wycenę partnera"
                            ></v-checkbox>
                          <v-textarea v-model="handOverData.wmNotes" label="Informacje od Wastemaster" rows="3"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                            v-text="this.order.status === 'partnerPriced' ? 'Przekaż do akceptacji' : 'Przekaż'"
                        ><v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
    name: 'ModalHandOverToPartner',
    props: {
        order: {},
    },
    created() {
    },
    data() {
        return {
            dialog: false,
            form: {
                email: '',
                typeForPartner: '',
                partnerPricing: false,
            },
            formRules: {
                email: [(value) => this.validateEmail((value || '')) || 'Wpisz adres e-mail'],
                typeForPartner: [(value) => !!value || 'Wybierz typ'],
            },
            valid: false,
            handOverData: {
                email: '',
                typeForPartner: '',
                partnerPricing: false,
                wmNotes: null,
            },
            typeValues: [
                {value: '', text: 'Wybierz typ'},
                {value: 'paidUtilization', text: 'Płatna utylizacja'},
                {value: 'wastePurchase', text: 'Kupno odpadu'},
                {value: 'wasteFree', text: 'Bezpłatny odbiór'},
            ],
        }
    },
    methods: {
        open() {
            this.dialog = true;

            this.handOverData.email = this.order.status === 'partnerPriced' ? this.order.partnerData.email : '';
            this.handOverData.typeForPartner = this.order.typeForPartner ?? '';
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            api
                .put(`/api/orders/${this.order.id}/handOver`, this.handOverData)
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Przekazano do partnera.',
                    });
                    this.dialog = false;
                    this.$parent.loadDetails();
                })
                .catch((error) => {
                    console.error('Error when editing a redirect:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd podczas przekazywania zamówienia',
                    });
                })
        },
        validateEmail(email) {
            const regex = /\S+@\S+\.\S+/;
            return regex.test(email);
        }
    },
}
</script>

<style scoped></style>
